import React from 'react';
import {Route} from 'react-router-dom';
import AsyncPage from './async';

export default [
  <Route
    key="/business/products/virtual-background"
    path="business/products/virtual-background"
    element={<AsyncPage />}
  />,
];
